import { render, staticRenderFns } from "./AppCardContent.vue?vue&type=template&id=5708b66a"
import script from "./AppCardContent.vue?vue&type=script&lang=js"
export * from "./AppCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports